import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

interface Props {
  open: boolean;
  onClose: () => void;
}

const ReserveInfoDialog = ({ open, onClose }: Props) => {
  const { t } = useLanguage();

  const handleGo = () => {
    onClose();
    const el = document.getElementById("produkter");
    if (el) el.scrollIntoView({ behavior: "smooth" });
    else window.location.href = "/#produkter";
  };

  return (
    <AnimatePresence>
      {open && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 z-[70] bg-background/80 backdrop-blur-sm"
          />
          <div className="fixed inset-0 z-[71] p-4 pointer-events-none">
            <motion.div
              initial={{ opacity: 0, y: 30, scale: 0.95 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 30, scale: 0.95 }}
              transition={{ duration: 0.3, ease: "easeOut" }}
              className="pointer-events-auto absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-md max-h-[85dvh] overflow-y-auto bg-background border border-primary/40 rounded-lg shadow-2xl p-6 md:p-8"
            >
              <button
                onClick={onClose}
                aria-label={t("reserve_info.close")}
                className="absolute right-2 top-2 text-foreground/60 hover:text-foreground p-1.5"
              >
                <X size={18} />
              </button>

              <h3 className="font-display text-xl md:text-2xl text-foreground tracking-tight mb-4 pr-8">
                {t("reserve_info.title")}
              </h3>
              <p className="text-sm md:text-base text-foreground/75 leading-relaxed mb-6">
                {t("reserve_info.body")}
              </p>

              <button
                onClick={handleGo}
                className="block w-full border border-primary/60 bg-primary/10 text-foreground font-display text-base tracking-[0.2em] py-3 rounded-md hover:bg-primary/20 transition-colors"
              >
                {t("reserve_info.cta")}
              </button>
            </motion.div>
          </div>
        </>
      )}
    </AnimatePresence>
  );
};

export default ReserveInfoDialog;
